package co.maytes.standupbot.dashboard.features.billing

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.features.integrations.LoadState
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.dashboard.stores.rememberApiClient
import co.maytes.standupbot.shared.dto.billing.BillingIntervalDto
import co.maytes.standupbot.shared.dto.billing.BillingPortalDto
import co.maytes.standupbot.shared.dto.billing.BillingStatusDto
import co.maytes.standupbot.shared.dto.billing.CheckoutSessionDto
import co.maytes.standupbot.shared.dto.billing.CreateCheckoutRequestDto
import co.maytes.standupbot.shared.dto.billing.PlanDto

class BillingStore(private val api: ApiClient) {
    var state: LoadState by mutableStateOf(LoadState.Idle)
        private set
    var status: BillingStatusDto? by mutableStateOf(null)
        private set

    var checkoutPending: Boolean by mutableStateOf(false)
        private set
    var portalPending: Boolean by mutableStateOf(false)
        private set

    suspend fun refresh(workspaceId: String) {
        state = LoadState.Loading
        when (val r = api.get<BillingStatusDto>("/api/v1/workspaces/$workspaceId/billing")) {
            is Result.Ok -> {
                status = r.value
                state = LoadState.Ready
            }
            is Result.Err -> state = LoadState.Error(r.error)
        }
    }

    suspend fun startCheckout(
        workspaceId: String,
        plan: PlanDto,
        interval: BillingIntervalDto,
    ): Result<CheckoutSessionDto, ApiError> {
        checkoutPending = true
        val r =
            api.post<CreateCheckoutRequestDto, CheckoutSessionDto>(
                path = "/api/v1/workspaces/$workspaceId/billing/checkout",
                body = CreateCheckoutRequestDto(plan = plan, interval = interval),
            )
        checkoutPending = false
        return r
    }

    suspend fun openPortal(workspaceId: String): Result<BillingPortalDto, ApiError> {
        portalPending = true
        val r = api.post<BillingPortalDto>("/api/v1/workspaces/$workspaceId/billing/portal")
        portalPending = false
        return r
    }
}

@Composable
fun rememberBillingStore(): BillingStore {
    val api = rememberApiClient()
    return remember(api) { BillingStore(api) }
}
